// extracted by mini-css-extract-plugin
export var SLVConversationViewSenderImageOff = "N2Z0S";
export var SLVConversationViewSenderImageOn = "EI6lL";
export var SLVItemViewSenderImageOff = "JjRxW";
export var SLVItemViewSenderImageOn = "L0ZVL";
export var actionHeaderThirdRow = "hYbe6";
export var full = "YzCsF";
export var inlineThirdRowContainer = "VXa5s";
export var leftEntitySingleLine = "Omg9q";
export var spinner = "KWNfJ";
export var thirdRowIcon = "VNKq5";
export var thirdRowTextSize = "k22kp";
export var thirdRowTextWithWarning = "OrdGo";
export var threeColConversationViewSenderImageOff = "vJjWW";
export var threeColConversationViewSenderImageOn = "C_FRW";
export var threeColItemViewSenderImageOff = "bpWGt";
export var threeColItemViewSenderImageOn = "TQSP6";